import { PayloadAction } from "@reduxjs/toolkit";
import { StatusLoading } from 'common/constants/statusLoading';

import { IState } from "../types/state";

const action = (state: IState, payloadAction: PayloadAction<StatusLoading | undefined>) => {
  state.filter.statusLoading = payloadAction.payload;
};

export default action;
